import { createSelector } from "reselect"
import { find, last, pick, chain, get } from "lodash"
import { computePerformanceData } from "helpers/analyze"
import { getSelectedContributorCategoryId } from "helpers/compositeSecuritiesDetails"

const getSelectedDate = (_, props) => props.selectedDate
const getAllCategoryItems = (_, props) => props.allCategoryItems
const getPerformanceHistory = (_, props) => props.performanceHistory

const getContributorData = createSelector(
  [getAllCategoryItems, getPerformanceHistory],
  computePerformanceData,
)

const getLastContributor = createSelector(
  [getContributorData],
  last,
)

export const getSelectedContributorCategory = createSelector(
  [getSelectedContributorCategoryId, getAllCategoryItems],
  (selected, items) => find(items, d => d.id === selected) || null,
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, date, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format("YYYY-MM-DD")) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format("YYYY-MM-DD"))
        if (contributor) {
          dayData = contributor
        }
      }
    }
    return chain(items)
      .map(item => ({
        ...pick(item, "label", "categoryLabel", "id", "color", "favorite", "field", "isAggregated"),
        value: dayData[item.id],
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getSelectedContributorValue = createSelector(
  [getDetails, getSelectedContributorCategory],
  (contributors, selected) => chain(contributors)
    .find({ id: get(selected, "id") })
    .get("value", 0)
    .value(),
)
